import { createSlice } from '@reduxjs/toolkit';

const STORAGE_KEY = 'timelineInternalNotifySeenFlights';

const loadPersistedSeenFlights = () => {
  if (typeof window === 'undefined') return [];

  try {
    const storedValue = window.localStorage.getItem(STORAGE_KEY);
    if (!storedValue) return [];

    const parsedValue = JSON.parse(storedValue);
    return Array.isArray(parsedValue) ? parsedValue : [];
  } catch (error) {
    return [];
  }
};

const persistSeenFlights = (seenFlights) => {
  if (typeof window === 'undefined') return;

  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(seenFlights));
  } catch (error) {
    // ignore storage write failures
  }
};

const initialState = {
  selectedToast: {
    message: '',
    statusType: '',
  },
  showToast: false,
  internalNotifyQueue: [],
  internalNotifySeenFlights: loadPersistedSeenFlights(),
};

const timelineToast = createSlice({
  name: 'timelineToast',
  initialState,
  reducers: {
    setToast: (state, action) => {
      state.selectedToast = {
        message: action.payload.message,
        statusType: action.payload.statusType,
      };
    },
    setShowToast: (state, action) => {
      state.showToast = action.payload;
    },
    clearToast: (state) => {
      state.selectedToast = {
        message: '',
        statusType: '',
      };
      state.showToast = false;
    },
    setInternalNotify: (state, action) => {
      if (Array.isArray(action.payload)) {
        state.internalNotifyQueue = action.payload;
        return;
      }

      if (action.payload && typeof action.payload === 'object') {
        const newNotification = action.payload;
        const notificationKey = newNotification.id || newNotification.flightId;

        const alreadyQueued = notificationKey && state.internalNotifyQueue.some((item) => (item.id || item.flightId) === notificationKey);
        if (alreadyQueued) {
          return;
        }

        state.internalNotifyQueue.push(newNotification);
        return;
      }

      state.internalNotifyQueue = [];
    },
    resetInternalNotify: (state) => {
      state.internalNotifyQueue = state.internalNotifyQueue.slice(1);
    },
    clearInternalNotify: (state) => {
      state.internalNotifyQueue = [];
    },
    markInternalNotifySeen: (state, action) => {
      const flightId = action.payload;
      if (!flightId) return;
      if (!state.internalNotifySeenFlights.includes(flightId)) {
        state.internalNotifySeenFlights.push(flightId);
      }
      persistSeenFlights(state.internalNotifySeenFlights);
    },
  },
});

export const { setToast, setShowToast, clearToast, setInternalNotify, resetInternalNotify, clearInternalNotify, markInternalNotifySeen } = timelineToast.actions;

export const selectSelectedToast = (state) => state.timelineToast.selectedToast;
export const selectShowToast = (state) => state.timelineToast.showToast;
export const selectInternalNotify = (state) => state.timelineToast.internalNotifyQueue?.[0];
export const selectInternalNotifyQueue = (state) => state.timelineToast.internalNotifyQueue;
export const selectInternalNotifySeenFlights = (state) => state.timelineToast.internalNotifySeenFlights;

export default timelineToast.reducer;
